import React from 'react'
import { equipmentExport, getEquipmentListing } from '../../Services/LocomotiveServices'
import Listing from '../../Components/Listing/Listing'
import { resetEquipmentFilters, setEquipmentFilters } from '../../redux/features/filterSlice'
import { useSelector } from 'react-redux'
const EquipmentLookup = () => {
    let value = useSelector((state) => state.filters)

    return (
        <Listing
            path={'/equipmentlookupedit'}
            ListingApi={getEquipmentListing}
            name={'Equipment'}
            exportListing={equipmentExport}
            setFilter={setEquipmentFilters}
            resetFilter={resetEquipmentFilters}
            state={value.equipmentFilters}
            showAddButton={false}
            showDeleteButton={false}
        />
    )
}
export default EquipmentLookup